import React, { useEffect, useState } from 'react';
import './styles.scss';
import LayoutComp from 'components/LayoutComp/Index';
import { Row, Checkbox, Tabs, Col, Button, Typography, Input } from 'antd';
import Navigation from 'components/Navigation';
import { STATIC_TEXT } from 'utils/constants';
import { BackArrow } from 'utils/svg';
import { useDispatch, useSelector } from 'react-redux';
import { fetchCategories, handleCategoriesSelection, emptyQuestionbyId } from './category.action';
import Loader from 'components/ui/Loader';
import DownloadModal from './Components/DownloadModal';
import { handleQuestionsSelection, handleReportName } from 'containers/Questions/question.action';

const QuestionCategory = ({ history }) => {
  const dispatch = useDispatch();
  const categoriesState = useSelector((state) => state.category);
  const { loader = false, catgoriesList = [], selectedCategories = [] } = categoriesState;
  const questionsState = useSelector((state) => state.question);
  const { reportName = '' } = questionsState;
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [localReportName, setLocalReportName] = useState('');
  const [hasError, setHasError] = useState(false);
  // console.log(isModalOpen);

  //   const [categories, setCategories] = useState(null);

  useEffect(() => {
    setLocalReportName(reportName);
  }, [reportName]);

  useEffect(() => {
    dispatch(handleQuestionsSelection([]));
    dispatch(fetchCategories());
    dispatch(emptyQuestionbyId());

    // eslint-disable-next-line
  }, [dispatch]);

  const showModal = () => {
    setIsModalOpen(true);
  };

  // const handleOk = () => {
  //   setIsModalOpen(false);
  // };

  const handleCancel = () => {
    dispatch(emptyQuestionbyId());
    setIsModalOpen(false);
  };

  const handleReset = () => {
    dispatch(handleCategoriesSelection([]));
  };
  // const handleNext = () => {
  //   history.push('/questions');
  // };
  const handleNext = () => {
    if (localReportName == '') {
      setHasError(true);
      // window.scrollTo(0, 0);
      return;
    }
    dispatch(handleReportName(localReportName));
    history.push('/questions');
  };

  const handleBack = () => {
    history.push('/');
  };

  const handleChange = (val) => {
    dispatch(handleCategoriesSelection(val));
  };
  // const handleTabChange = (val) => {
  //   console.log(val);
  //   dispatch(fetchquestionnaireNames(val));
  // };

  const reportNameChange = (e) => {
    if (e.target.value !== '') {
      setHasError(false);
    } else {
      setHasError(true);
    }
    setLocalReportName(e.target.value);
  };

  return (
    <div className="Dashboard">
      <LayoutComp history={history}>
        <div id="surveyType">
          <div className="back-nav">
            <div onClick={handleBack}>
              <BackArrow />
            </div>
            {STATIC_TEXT['SELECT_OPTION']}
          </div>

          <div className="downloadbtn-cat">
            <Button onClick={showModal}>Download Questionnaire</Button>
          </div>
          <p className="sub-heading">{STATIC_TEXT['SELECT_OPTION_TO_DOWNLOAD_YOUR_SURVEY']}</p>

          <Checkbox.Group
            value={selectedCategories || []}
            onChange={handleChange}
            style={{
              width: '100%',
              minHeight: 350
            }}
          >
            <Row style={{ marginBottom: 15 }}>
              {loader ? (
                <Loader />
              ) : (
                <Col span={24}>
                  <Tabs
                    items={catgoriesList.map((item, index) => {
                      return (
                        item.title !== 'No Category' && {
                          key: index,
                          label: item.title,
                          children: item.subcategories.map((childitem, cindex) => (
                            <div key={`child_${cindex}`} className="catcheckbox">
                              <Checkbox value={childitem.id}>{childitem.title}</Checkbox>
                            </div>
                          ))
                        }
                      );
                    })}
                  />
                </Col>
              )}
            </Row>
          </Checkbox.Group>

          <DownloadModal isModalOpen={isModalOpen} handleCancel={handleCancel} />

          {!loader && (
            <Row style={{ justifyContent: 'center' }}>
              <Col>
                <div className="downloadbtn-cat2">
                  <Typography.Title level={5} style={{ margin: 0 }}>
                    Please Enter Questionnaire Name<sup>*</sup>
                  </Typography.Title>
                  <Input
                    size="large"
                    placeholder="Report name"
                    value={localReportName || ''}
                    onChange={reportNameChange}
                    style={{ width: 300 }}
                  />
                  {hasError && <div className="hasError">This field is required!</div>}
                </div>
              </Col>
              <Col>
                <Navigation
                  isDisabledNext={selectedCategories.length < 1}
                  isReset={true}
                  handleNext={handleNext}
                  handleReset={handleReset}
                />
              </Col>
            </Row>
          )}
        </div>
      </LayoutComp>
    </div>
  );
};

export default QuestionCategory;
